import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth/authservice.service';
import { AuthenticationService }from '../services/index';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router,private authService: AuthService,private authenticationService: AuthenticationService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('token') && this.authService.isTokenNotExpired()) {
            return true;
       }
        // Clear session and redirect to login
        localStorage.clear();
        this.router.navigate(['/login'], { 
            queryParams: { returnUrl: state.url, error: 'session_expired' } 
        });
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/common/auth.guard.ts